import type { IconConfig } from '#types/config/components/icon'

export default {
  paths: () => [
    ['M2,2.5 L8,2.5', 'M5,5 L7.5,2.5'],
    ['M2,5 L8,5', 'M2.5,2.5 L7.5,7.5'],
    ['M2,7.5 L8,7.5', 'M2.5,7.5 L5,5']
  ]
} satisfies IconConfig['menu']
